module.exports = __webpack_public_path__ + "img/logo2.c4f439ea.svg";